import React, { useEffect, useState }           from 'react'
import Grid                                     from '@material-ui/core/Grid'
import ModalComponent                           from './ModalComponent'
import PropTypes                                from 'prop-types'
import ShowHistoryPhoto                         from './ShowHistoryPhoto'
import { store }                                from '../Redux/Store'
import Typography                               from '@material-ui/core/Typography'


const GuestBioHistoryEntryReadComponent = ( { entry, handleSelect } ) => {

   const { superUser }                                               =  store.getState()

   const [ displayEntries,                      setDisplayEntries ]  =  useState([])
   const [ displayLinks,                        setDisplayLinks   ]  =  useState([])
   const [ displayTitle,                        setDisplayTitle   ]  =  useState('')
   const [ id,                                  setId             ]  =  useState('')
   const [ isOpen,                              setIsOpen         ]  =  useState(false)

   const closeModal = () => {
      setIsOpen(false)
   }

   const handleModal = ( id ) => {
      setId(id)
      setIsOpen(true)
   }

   const handleClick = (id) => {
      console.log('Guest bio History Entry Read Component item is', id)
      handleSelect(id)
   }

   const handleTitle = () => {
      console.log('Guest bio History Entry Read Component Title was clicked')
      handleClick('title')
   }

   useEffect( () => {
      if (entry && entry.title) {
         if (superUser) {
            setDisplayTitle(
               <Typography key={entry._id} variant='h5' align='left' style={{ marginBottom: '5px', marginTop: '5px' }} onClick={() => handleClick('title')} >
                  { entry.title }
               </Typography>
            )
         }
         else {
            setDisplayTitle(
               <Typography key={entry._id} variant='h5' align='left' style={{ marginBottom: '5px', marginTop: '5px' }} >
                  { entry.title }
               </Typography>
            )
         }
      }

      if (entry && entry.entries && entry.entries.length > 0) {
         setDisplayEntries(
            entry.entries.map( (e, i) => {
               if (e.entryType === 'text') {
                  if (superUser) {
                     return(
                        <Typography key={entry._id + i} style={{ textAlign: 'left', marginBottom: '10px' }} onClick={() => handleClick(e._id)} >
                           { e.entry }
                        </Typography>
                     )
                  }
                  else {
                     return(
                        <Typography key={entry._id + i} style={{ textAlign: 'left', marginBottom: '10px' }} >
                           { e.entry }
                        </Typography>
                     )
                  }
               }
               else if(e.entryType === 'bullet') {
                  if (superUser) {
                     return(
                        <Typography key={entry._id + i} style={{ textAlign: 'left', marginBottom: '10px', marginLeft: '20px' }} onClick={() => handleClick(e._id)} >
                           { e.entry }
                        </Typography>
                     )
                  }
                  else {
                     return(
                        <Typography key={entry._id + i} style={{ textAlign: 'left', marginBottom: '10px', marginLeft: '20px' }} >
                           { e.entry }
                        </Typography>
                     )
                  }
               }
               else if(e.entryType === 'photo') {
                  return(
                     <Grid key={e._id + i} >
                        <ShowHistoryPhoto entry={e} />
                     </Grid>
                  )
               }
               return null
            } )
         )
      }

      if (entry && entry.links && entry.links.length > 0) {
         setDisplayLinks(
            entry.links.map( (link, i) => {
               return(
                  <Typography key={link._id + i} variant='h6' style={{ textAlign: 'left', marginBottom: '10px', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleModal(link.id)} >
                     { link.caption }
                  </Typography>
               )
            })
         )
      }

   }, [entry] )

   return(
      <Grid>
         { displayTitle }
         { displayEntries }
         { displayLinks }
         { isOpen ? <ModalComponent closeModal={closeModal} id={id} /> : null }
      </Grid>
   )
}

GuestBioHistoryEntryReadComponent.propTypes = {
  entry:                                        PropTypes.object,
  handleSelect:                                 PropTypes.func
}

export default GuestBioHistoryEntryReadComponent
